var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":"Quy định"}},[_c('embed',{attrs:{"src":"https://nb.hoplucpost.vn/logistic-web/privacy/quy-dinh-hang-gui.pdf","type":"application/pdf","frameBorder":"0","scrolling":"auto","height":"700","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }